module.exports = __webpack_public_path__ + "img/conversion_rates.a6087c7a.png";